webpackJsonp([5],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

/*
	Компілюється у файл
*/
 true ? true : require('__page/knowledge-base.html');

/*
	Підключаєм конструктор модулів
*/
var mc = __webpack_require__(3);
var Share = __webpack_require__(6);
var Inputmask = __webpack_require__(5);

/**
	Запускаєм конструктор модулів. Аргументом приймає масив назв vue-компонентів,
	які треба включити в процес збірки проекту.
	@type {Array<String>}
*/
mc(['Navigation', 'Slider', 'Form']);

var completeEmail = false;
var showRequiredEmail = false;

var email = new Inputmask({
	mask: window.YAMASTERS_FRONTEND.validator.mask.email,
	greedy: false,
	definitions: {
		'*': {
			validator: "[0-9A-Za-z_-]",
			cardinality: 1,
			casing: "lower"
		},
		'@': {
			validator: '@',
			cardinality: 1,
			casing: 'lower'
		},
		'd': {
			validator: '.',
			cardinality: 1,
			casing: 'lower'
		}
	},
	oncomplete: function oncomplete() {
		// console.log('oncomplete');
		completeEmail = true;
		showRequiredEmail = false;
	},
	onincomplete: function onincomplete() {
		completeEmail = false;
	},
	oncleared: function oncleared() {
		completeEmail = false;
	}
});
email.mask($('.mail'));

new Share();

/*
	Запускаєм скріпти html компонентів
*/
STACK.forEach(function (f) {
	f($);
});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Share = function () {
	function Share() {
		_classCallCheck(this, Share);

		// розміри вікна
		this._vw = window.innerWidth;
		this._vh = window.innerHeight;

		// параметри вікна, в якому відкриється розшарювання
		this._p1 = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600,left=' + (this.vw - 600) / 2 + ',top=' + (this.vh - 600) / 2;
		this._p2 = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=700,width=1024,left=' + (this.vw - 1024) / 2 + ',top=' + (this.vh - 700) / 2;

		// масив із кнопок
		this._links = [];

		// загальний селектор для всіх кнопок шари
		// TODO: можливо додати це поле як вхідні дані для класу
		this._selector = '.sharelink';

		this.init();
	}

	_createClass(Share, [{
		key: 'init',
		value: function init() {
			var _this2 = this;

			var b = document.querySelectorAll(this.selector);

			if (b.length) {
				var _loop = function _loop(i) {
					var _this = _this2;

					b[i].addEventListener('click', function (e) {
						e.preventDefault();

						if (b[i].classList.contains('facebook')) {
							window.open('https://www.facebook.com/sharer/sharer.php?u=' + this['getAttribute']('data-share-url'), '', _this.p1);
							return false;
						} else if (b[i].classList.contains('twitter')) {
							window.open('https://twitter.com/home?status=' + this['getAttribute']('data-share-url'), '', _this.p1);
							return false;
						} else if (b[i].classList.contains('googleplus')) {
							window.open('https://plus.google.com/share?url=' + this['getAttribute']('data-share-url'), '', _this.p1);
							return false;
						} else if (b[i].classList.contains('linkedin')) {
							window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + this['getAttribute']('data-share-url'), '', _this.p2);
							return false;
						} else {
							console.warn('Unknown share button.');
						}
					});
				};

				for (var i = 0; i < b.length; i++) {
					_loop(i);
				}
			}
		}
	}, {
		key: 'selector',
		get: function get() {
			return this._selector;
		}
	}, {
		key: 'p1',
		get: function get() {
			return this._p1;
		}
	}, {
		key: 'p2',
		get: function get() {
			return this._p2;
		}
	}, {
		key: 'vw',
		get: function get() {
			return this._vw;
		}
	}, {
		key: 'vh',
		get: function get() {
			return this._vh;
		}
	}]);

	return Share;
}();

module.exports = Share;

/***/ })

},[201]);


// WEBPACK FOOTER //
// bundles/knowledge-base.bundle.js